import { render } from "./np-collapsible.vue?vue&type=template&id=c0ea020c"
import script from "./np-collapsible.vue?vue&type=script&lang=js"
export * from "./np-collapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__